import { Center } from "@chakra-ui/react";
import { Attribute, Node } from "@tiptap/core";
import { NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";
import { ImageHasBlackboardValue } from "components/containers/inspectionSetting/containers/templateBuilder/fields/imageHasBlackboard/previewer";
import ImageWithBlackboard from "components/containers/inspectionSetting/containers/templateBuilder/fields/imageHasBlackboard/previewer/ImageWithBlackboard";
import { PhotoBlackboardIcon } from "components/icon";
import { PinContent, PinDetail } from "interfaces/models/pin";
import { useMemo } from "react";
import { CustomNodeComponentProps, NodeType } from "../../type";
import { IMAGE_THUMB_ICON_CLASSNAME } from "constants/styleProps";

export interface ImageBlackboardNodeAttrs {
  pinContent: PinContent | undefined;
  pinDetail: PinDetail | undefined;
}

export const ImageBlackboardNode = Node.create({
  name: NodeType.IMAGE_BLACKBOARD,
  group: "block",
  isolating: true,
  selectable: false,

  addAttributes() {
    const attrs: {
      [key in keyof ImageBlackboardNodeAttrs]: Attribute;
    } = {
      pinContent: { default: undefined },
      pinDetail: { default: undefined },
    };

    return attrs;
  },
  parseHTML() {
    return [
      {
        tag: "image-blackboard",
      },
    ];
  },
  renderHTML() {
    return ["image-blackboard", {}, 0];
  },

  addNodeView() {
    return ReactNodeViewRenderer(Component);
  },
});

const Component = (
  props: CustomNodeComponentProps<ImageBlackboardNodeAttrs>
) => {
  const { pinDetail, pinContent } = props.node.attrs;
  const editorAttributes = props.editor.options.editorProps?.attributes as any;
  const isPreview = editorAttributes?.isPreview === "true";

  const content = pinContent?.value?.data as
    | ImageHasBlackboardValue
    | undefined;

  const formValue = useMemo(() => {
    if (!pinDetail?.pinContents) {
      return {};
    }
    const formValue: Record<string, any> = {};
    pinDetail?.pinContents.forEach(
      (pinContent) =>
        (formValue[pinContent.itemResultId] = pinContent.value?.data)
    );

    return formValue;
  }, [pinDetail?.pinContents]);

  return (
    <NodeViewWrapper
      style={{
        position: "relative",
        height: "100%",
        width: "100%",
        cursor: "default",
        pointerEvents: "auto",
      }}
      className={content?.src ? "wrapper-node-image" : undefined}
      onClick={(e: any) => {
        if (e.target.closest(`.${IMAGE_THUMB_ICON_CLASSNAME}`)) {
          props.editor.commands.blur();
        } else {
          e.stopPropagation();
        }
      }}
    >
      {content?.src && !isPreview && (
        <Center
          bg="rgba(221, 206, 110, 0.6)"
          w="4rem"
          h="4rem"
          color="white"
          position="absolute"
          right="0"
          top="0"
          cursor="pointer"
          className={IMAGE_THUMB_ICON_CLASSNAME}
          zIndex="docked"
        >
          <PhotoBlackboardIcon width="2.2rem" height="2.2rem" />
        </Center>
      )}

      <Center width="100%" height="100%">
        <ImageWithBlackboard
          src={content?.src}
          pinDetail={pinDetail}
          defaultFormValue={formValue}
          blackboardData={content?.blackboardData}
          isModeEditor={true}
        />
      </Center>
    </NodeViewWrapper>
  );
};
